import { useCallback } from "react";

import { notification } from "@/components/ui-deprecated";
import { BookmarkItem } from "@/features/bookmarks/bookmarks.types";
import { useAppSelector, useAppDispatch } from "@/store";
import { addBookmark, removeBookmark } from "@/store/slices/bookmark.slice";

export const useBookmarksActions = () => {
    const dispatch = useAppDispatch();

    const userId = useAppSelector((state) => state.user.id);
    const isInitialized = useAppSelector((state) => state.bookmark.isInitialized);

    const addBookmarkAction = useCallback(
        (item: BookmarkItem) => {
            dispatch(addBookmark({ userId, bookmark: item }));
            notification.success(`"${item.title}" added to Bookmarks`);
        },
        [dispatch, userId],
    );

    const removeBookmarkAction = useCallback(
        (type: string, id: string) => {
            dispatch(removeBookmark({ userId, id, type }));
            notification.success(`Removed from Bookmarks`);
        },
        [dispatch, userId],
    );

    return {
        addBookmarkAction,
        removeBookmarkAction,
        isInitialized,
    };
};
